{
  const CLASS_FIT_TO_CONTENT = 'is__fitToContent';

  const BaseModule = require('_base/base');

  class FitToProportionModule extends BaseModule {
    postInit() {
      this.givenProportion = this._parseProportion();
      this.shouldFitToModule = !this.$el.hasClass(CLASS_FIT_TO_CONTENT);
    }

    _parseProportion() {
      const proportion = this.$el.data('fit-to-proportion');

      if (typeof proportion === 'string') {
        if (proportion.indexOf('%') > -1) {
          return parseFloat(proportion) / 100;
        } else if (proportion.indexOf(':') > -1) {
          const portions = proportion.split(':');
          return portions[0] / portions[1];
        }
      }

      return proportion;
    }

    preReset() {
      this.$el.removeClass(CLASS_FIT_TO_CONTENT);

      this.$el.css({
        flex: 1,
      });
    }

    preCalculate() {
      this.width = this.$el.width();
      this.calculatedHeight = (this.width / this.givenProportion).toFixed();

      if (this.shouldFitToModule) {
        this.height = this.$el.height();

        if (this.calculatedHeight > this.height && this.height > 0) {
          this.calculatedHeight = this.height;
        }
      }
    }

    postRender() {
      this.$el.addClass(CLASS_FIT_TO_CONTENT);

      this.$el.css({
        flexGrow: 0,
        flexBasis: `${this.calculatedHeight}px`,
      });
    }
  }

  $('.js__fitToProportion').each(function() {
    new FitToProportionModule($(this));
  });
}
